import { Component, OnChanges, OnInit } from '@angular/core';
import { FieldWrapper } from '@ngx-formly/core';

@Component({
  selector: 'eos-tooltip-wrapper',
  templateUrl: './tooltip-wrapper.component.html',
  styleUrls: ['./tooltip-wrapper.component.css']
})
export class TooltipWrapperComponent extends FieldWrapper implements OnInit {
  onlyTooltipWrapper = false;
  
  constructor() {
    super();
  }

  ngOnInit() {
    if (this.field.wrappers !== undefined) {
      this.onlyTooltipWrapper = this.field.wrappers.filter(w => w !== 'tooltip-field').length < 1;
    }
  }
  closeTooltipWithDelay(tooltip: any, delay: number = 2000) {
  setTimeout(() => tooltip.close(), delay);
}
  showTooltip(): boolean {
    // Check if the tooltip content is provided and not empty
    const tooltipContent = this.to.tooltip?.content;
    return tooltipContent && tooltipContent.trim() !== '';
  }
  isToolTipAlignmentAdjustRequired(): boolean {
    //added to align tooltip in case of phone number field
    return this.to.tooltip?.isToolTipAdjustRequired;
  }

}
